<template>
  <div :class="{ 'only-missing-translations': onlyMissingTranslations }">
    <div class="flex justify-between mb-8">
      <h3 class="text-3xl font-bold">
        {{ data.branch }} (
        <span
          class="hover:text-blue-500 cursor-pointer min-h-0"
          @click="destroy">delete</span>
        )
      </h3>
      <textarea
        v-model="dlCommand"
        class="p-4 bg-gray-300 font-mono w-1/3 block text-xs"
        rows="1"
        @mousedown.prevent="$event.target.select()"/>
    </div>
    <document-node
      v-for="node in nodes"
      :key="node.title"
      :node="node"
      :langs="langs"
      :pictures="pictures"/>
    <div
      class="pl-2 pb-2 rounded cursor-pointer text-white fixed bottom-0 left-0 fixed text-4xl leading-none"
      @click="onlyMissingTranslations = !onlyMissingTranslations">
      {{ onlyMissingTranslations ? '📘' : '📖' }}
    </div>
  </div>
</template>

<script>
  import { flatten, groupBy, uniq } from 'lodash'
  import DocumentNode from '@/components/DocumentNode'
  import firebase from 'firebase'

  export default {
    data () {
      return {
        document: {},
        entries: [],
        pictures: {},
        onlyMissingTranslations: true
      }
    },

    computed: {
      data () {
        return (this.document.data && this.document.data()) || {}
      },
      dlCommand () {
        return `yarn tr:dl ${this.$route.params.id}`
      },
      langs () {
        return uniq(flatten(this.entries.map(entry => Object.keys(entry)))).filter(k => k[0] !== '_')
      },
      nodes () {
        return entriesToNodes(this.entries)
      }
    },

    mounted () {
      firebase.firestore().collection('projects').doc(this.$route.params.id).onSnapshot(querySnapshot => {
        this.document = querySnapshot
        this.document.ref.collection('lang').onSnapshot(querySnapshot => {
          this.entries = querySnapshot.docs.map(doc => {
            const data = doc.data()
            return { ...data, _key: JSON.parse(data._key), _ref: doc.ref }
          })
        })
      })
      this.fetchPictures()
    },

    methods: {
      destroy () {
        if (!confirm('Do you really want to delete this tranlsation request ?')) return
        this.document.ref.delete()
        this.$router.replace('/')
      },

      async fetchPictures () {
        const pictures = await firebase.app().storage().ref().child(`projects/${this.$route.params.id}/pictures`).listAll().then(res => res.items)
        await Promise.all(pictures.map(async item => { item.downloadURL = await item.getDownloadURL() }))
        this.pictures = groupBy(pictures, p => p.name)
      }
    },

    components: {
      DocumentNode
    }
  }

  const entriesToNodes = (entries, depth = -1) => {
    entries = entries.filter(entry => entry._key.length > depth)
    const grouped = groupBy(entries, entry => depth === -1 ? entry._folder : entry._key[depth])
    return Object.entries(grouped).map(([title, value]) => {
      return { title, entries: value, childNodes: entriesToNodes(value, depth + 1) }
    })
  }
</script>
